.root {
  --result-color: var(--color-accent);
  position: absolute;
  z-index: 3;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  gap: var(--space-3);
  padding: var(--space-4);
  overflow: auto;
  color: var(--color-text-primary);
  background: color-mix(in srgb, var(--color-profile-content) 82%, transparent);
  backdrop-filter: blur(8px);
  text-align: center;
}
.root > * {
  flex-shrink: 0;
  max-width: 100%;
}
.title,
.reward,
.check {
  color: var(--result-color);
}
.title {
  font-size: clamp(1rem, 3vw, 1.5rem);
  font-weight: 800;
}
.reward,
.reward > strong {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  font-weight: 800;
}
.reward {
  flex-wrap: wrap;
}
.reward img {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
}
.check {
  padding: var(--space-2);
  box-sizing: content-box;
  border-radius: 50%;
  background: color-mix(in srgb, var(--result-color) 14%, transparent);
}
@media (prefers-reduced-motion: no-preference) {
  .root[data-correct] {
    animation: reveal 240ms ease-out both;
  }
  .root[data-correct] .check {
    animation: celebrate 420ms cubic-bezier(0.2, 0.8, 0.3, 1.3) both;
  }
  .root[data-correct] .reward {
    animation: reveal 320ms 90ms ease-out both;
  }
}
@keyframes reveal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes celebrate {
  from {
    opacity: 0;
    transform: scale(0.65) rotate(-12deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

.heading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
}
@media (max-width: 39.99em) {
  .root {
    gap: var(--space-2);
    padding: var(--space-3);
  }
  .check {
    width: 1.25rem;
    height: 1.25rem;
    padding: var(--space-1);
  }
}

:global([data-mantine-color-scheme='light']) .root {
  --result-color: var(--color-brand);
}
.root > button,
.root > a {
  padding-inline: 3rem;
}
.root > :global([data-variant='game']) {
  background-color: var(--color-accent);
}
.root > h2,
.root > p {
  margin: 0;
}
.root > h2 {
  font-size: clamp(1.125rem, 4vw, 1.75rem);
  font-weight: 800;
}
@media (max-width: 39.99em) {
  .root > button,
  .root > a {
    width: 100%;
    min-height: var(--control-height);
  }
}
